import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import TodayUpdates from './components/TodayUpdates';
import HotMovies from './components/HotMovies';
import GenreBrowse from './components/GenreBrowse';
import HdZone from './components/HdZone';
import ClassicPicks from './components/ClassicPicks';
import Upcoming from './components/Upcoming';
import Guide from './components/Guide';
import Faq from './components/Faq';

const keywords = [
  '最新电影',
  '电影大全',
  '高清电影',
  '今日更新',
  '热门影片',
  '电影资源',
  '4K HDR',
  '蓝光修复',
  '动作片',
  '科幻片',
  '悬疑片',
  '动画电影',
  '纪录片',
  '经典重映',
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />

        <div className="w-full bg-foreground-950 py-4 overflow-hidden">
          <div className="flex w-max animate-marquee">
            {[0, 1].map((row) => (
              <ul key={row} className="flex items-center" aria-hidden={row === 1}>
                {keywords.map((k) => (
                  <li key={`${row}-${k}`} className="flex items-center shrink-0">
                    <i className="ri-movie-2-line text-primary-400 mx-4"></i>
                    <span className="text-sm text-background-100 whitespace-nowrap">{k}</span>
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </div>

        <TodayUpdates />
        <HotMovies />
        <GenreBrowse />
        <HdZone />
        <ClassicPicks />
        <Upcoming />
        <Guide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}